import React, { Component } from 'react'

import ProfilesSection from '../ProfilesSection'
import InvestorsInfoSection from '../InvestorInfoSection'

interface Props {}

interface State {
  tabCorporateGovernanceActive: boolean
}

export default class TabsSection extends Component<Props, State> {
  state: State = {
    tabCorporateGovernanceActive: false
  }

  updateTabCorporateGovernanceActiveStatus = (status: boolean) => {
    this.setState({ tabCorporateGovernanceActive: status })
  }

  render() {
    const { tabCorporateGovernanceActive } = this.state
    return (
      <>
      <ProfilesSection
        onInternTabSwitch={this.updateTabCorporateGovernanceActiveStatus}
        tabCorporateGovernanceActive={tabCorporateGovernanceActive}
      />
     <InvestorsInfoSection tabCorporateGovernanceActive={tabCorporateGovernanceActive}/>
      </>
    )
  }
}
